import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-shilpi',
  templateUrl: './shilpi.component.html',
  styleUrls: ['./shilpi.component.scss']
})
export class ShilpiComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getShilpi();
  }
}
